import { Pipe, PipeTransform } from '@angular/core';

const units: string[] = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

export const formatFileSize = (
  bytes: number = 0,
  precision: number = 2,
): string => {
  if (Number.isNaN(parseFloat(String(bytes))) || !Number.isFinite(bytes)) {
    return 'n/a';
  }

  let unit = 0;
  let parsedBytes = bytes;

  while (parsedBytes >= 1024) {
    parsedBytes /= 1024;
    unit += 1;
  }

  if (unit === 0) {
    return '< 1 KB';
  }

  return `${parsedBytes.toFixed(+precision)} ${units[unit]}`;
};

/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that defaults to 2.
 * Usage:
 *   bytes | fileSize:precision
 * Example:
 *   {{ 1024 |  fileSize}}
 *   formats to: 1 KB
 *
 * https://gist.github.com/JonCatmull/ecdf9441aaa37336d9ae2c7f9cb7289a
 */
@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  /**
   * formats a given fileSize
   */
  transform(bytes: number = 0, precision: number = 2): string {
    return formatFileSize(bytes, precision);
  }
}
